"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mixpanel = void 0;
const mixpanel_browser_1 = require("mixpanel-browser");
const mixpanelActions = {
    name: 'Mixpanel',
    init: ({ isProduction, tokens, bypassProductionCheck }) => {
        try {
            if (!tokens['Mixpanel']) {
                console.warn('Cannot initialize Mixpanel. Mixpanel project token is not defined.');
                return false;
            }
            if (isProduction || bypassProductionCheck) {
                mixpanel_browser_1.default.init(tokens['Mixpanel']);
            }
        }
        catch (e) {
            console.error('Mixpanel initialization failed');
            return false;
        }
        return true;
    },
    identify: ({ userInfo, appInfo, clinicInfo, isProduction, logRocketSessionUrl, bypassProductionCheck, }) => {
        try {
            /**
             * Mixpanel.register() adds super properties, i.e. properties that are sent with every event.
             * For details: https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript#super-properties
             */
            if (isProduction || bypassProductionCheck) {
                const registerProps = {
                    appName: appInfo === null || appInfo === void 0 ? void 0 : appInfo.name,
                    appVersion: appInfo === null || appInfo === void 0 ? void 0 : appInfo.version,
                    commitHash: appInfo === null || appInfo === void 0 ? void 0 : appInfo.commitHash,
                    commitNumber: appInfo === null || appInfo === void 0 ? void 0 : appInfo.commitNumber,
                    clinicId: clinicInfo === null || clinicInfo === void 0 ? void 0 : clinicInfo.id,
                    clinicName: clinicInfo === null || clinicInfo === void 0 ? void 0 : clinicInfo.name,
                    logRocketSessionUrl,
                };
                mixpanel_browser_1.default.register(registerProps);
                mixpanel_browser_1.default.identify(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id);
                mixpanel_browser_1.default.people.set({
                    userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                    application: appInfo === null || appInfo === void 0 ? void 0 : appInfo.name,
                    appName: appInfo === null || appInfo === void 0 ? void 0 : appInfo.name,
                    clinicName: (clinicInfo === null || clinicInfo === void 0 ? void 0 : clinicInfo.name) || 'Unknown clinic',
                });
            }
        }
        catch (_a) {
            console.error('Mixpanel identify failed');
            return false;
        }
        return true;
    },
    track: ({ isProduction, eventName, eventData, bypassProductionCheck, }) => {
        try {
            if (isProduction || bypassProductionCheck) {
                mixpanel_browser_1.default.track(eventName, eventData);
            }
        }
        catch (e) {
            console.error('Mixpanel track failed');
            return false;
        }
        return true;
    },
    reset: (isProduction, bypassProductionCheck) => {
        try {
            if (isProduction || bypassProductionCheck) {
                mixpanel_browser_1.default.reset();
            }
        }
        catch (e) {
            console.error('Mixpanel reset failed');
            return false;
        }
        return true;
    },
};
exports.Mixpanel = mixpanelActions;
//# sourceMappingURL=index.js.map